import { BasePage } from "../base/base";

const NotFoundPage = () => {
  return (
    <BasePage>
      <h1>Not Found</h1>
      <p>This page does not exist</p>
    </BasePage>
  );
};

export { NotFoundPage };
